import qs from "qs";

const STORAGE_KEY = "mass_ticketing_attribution";

const STANDARD_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "fbclid",
  "gclid",
];

// Non-standard marketing params worth keeping in the catch-all.
const KNOWN_EXTRA_KEYS = [
  "utm_id",
  "ttclid",
  "msclkid",
  "gbraid",
  "wbraid",
  "brid",
  "_kx",
];

const isExtraKey = (key) =>
  /^utm_/i.test(key) || /clid$/i.test(key) || KNOWN_EXTRA_KEYS.includes(key);

/**
 * Capture marketing attribution from the current URL on first load and persist
 * it to sessionStorage. First-touch wins: once stored, it is not overwritten.
 */
export const captureAttribution = () => {
  try {
    if (sessionStorage.getItem(STORAGE_KEY)) {
      return;
    }
    const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    const data = {};
    const extra = {};
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value == null || value === "") {
        return;
      }
      if (STANDARD_KEYS.includes(key)) {
        data[key] = String(value);
      } else if (isExtraKey(key)) {
        extra[key] = String(value);
      }
    });

    const referrer = document.referrer || "";
    const hasSignal =
      STANDARD_KEYS.some((key) => data[key]) ||
      Object.keys(extra).length > 0 ||
      Boolean(referrer);
    if (!hasSignal) {
      return;
    }

    data.referrer = referrer;
    data.landing_url = window.location.href || "";
    if (Object.keys(extra).length > 0) {
      data.attribution_extra = extra;
    }

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (e) {
    // sessionStorage may be unavailable (private mode); ignore.
  }
};

/** Return the stored attribution object, or null if none captured. */
export const getAttribution = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};
